module.exports = __webpack_public_path__ + "static/img/bc1-6.a94107d.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/SaveFile/bc1-6.png
// module id = 825
// module chunks = 0